<template>
  <div class="buy-set-content pl16 pr16">
    <!--其他设置-->
    <div class="common-form mt50">其他设置</div>
    <el-form-item label="允许加入购物车：">
      <el-radio-group v-model="form.model.is_cart">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="佣金支付：" v-auth="'/plus/agent/setting/commissionpay'">
      <el-radio-group v-model="form.model.is_commission_pay">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="商品属性：" v-if="!form.isTypeLocked">
      <el-radio-group v-model="form.model.is_virtual">
        <el-radio :label="0">普通实物商品</el-radio>
        <el-radio :label="1">虚拟商品(无需发货)</el-radio>
        <el-radio :label="10"  v-auth="'/product/product/diy'" >定制商品</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="虚拟商品类型：" v-if="form.model.is_virtual==1 && !form.isTypeLocked">
      <el-radio-group v-model="form.model.virtual_type">
        <el-radio :label="0" >普通</el-radio>
        <el-radio :label="1" v-auth="'/product/active/index'">活动</el-radio>
        <el-radio :label="2" v-auth="'/plus/course/index'">视频课程</el-radio>
        <!-- <el-radio :label="3" >景区门票</el-radio> -->
      </el-radio-group>
    </el-form-item>
    <el-form-item label="商品属性：" v-if="form.isTypeLocked">
      <el-radio-group v-model="form.model.is_virtual">
        <el-radio :label="0"  disabled="">普通实物商品</el-radio>
        <el-radio :label="1"  disabled="">虚拟商品(无需发货)</el-radio>
        <el-radio :label="10" v-auth="'/product/product/diy'"  disabled="">定制商品</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="定制海报：" prop="custom_poster" v-if="form.model.is_virtual==10">
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="openUpload()">选择图片</el-button>
        <div class="draggable-list">
          <div v-if="form.model.custom_poster" class="img item">
            <img :src="form.model.custom_poster" width="100" height="100" alt="custom_poster"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgPoster"><i class="el-icon-close"></i></a>
          </div>
        </div>
        <div class="gray9">推荐尺寸：750x1100</div>
      </el-row>
    </el-form-item>
    <el-form-item label="定制说明：" v-if="form.model.is_virtual==10">
      <el-input type="textarea" :rows="8" v-model="form.model.custom_remark" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="虚拟商品类型：" v-if="form.model.is_virtual==1 && form.isTypeLocked">
      <el-radio-group v-model="form.model.virtual_type">
        <el-radio :label="0" disabled="" >普通</el-radio>
        <el-radio :label="1" disabled="" v-auth="'/product/active/index'">活动</el-radio>
        <el-radio :label="2" disabled="" v-auth="'/plus/course/index'">视频课程</el-radio>
        <el-radio :label="3" disabled="" v-auth="'/plus/gradecard/index'">景区预约</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="form.isTypeLocked" class="red">此商品选定类型后不能修改！</el-form-item>
    <div v-if="form.model.is_virtual==1 && (form.model.virtual_type ==1||form.model.virtual_type ==3) ">


      <el-form-item v-if="form.model.virtual_type ==1" label="活动时间" :rules="[{ required: true, message: ' ' }]" prop="model.active.active_time">
        <el-date-picker
          v-model="form.model.active.active_time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="活动开始日期"
          end-placeholder="活动结束日期"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :picker-options="pickerOptions"
          ></el-date-picker>
      </el-form-item>
      <el-form-item  v-if="form.model.virtual_type ==1"  label="核销次数：" :rules="[{ required: true, message: ' ' }]" prop="model.active.number">
        <el-input type="number"  v-model="form.model.active.number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="所属门店">
        <el-select v-model="form.model.store_id"  :rules="[{ required: true, message: ' ' }]" placeholder="请选择">
          <el-option v-for="(item,index) in form.store_list" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地点：" :rules="[{ required: true, message: ' ' }]" prop="model.active.address">
        <el-input type="text"  v-model="form.model.active.address" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="地点坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.model.active.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>

      </el-form-item>
      <el-form-item  v-if="form.model.virtual_type ==1"  label="活动联系人：" :rules="[{ required: true, message: ' ' }]" prop="model.active.name">
        <el-input type="text"  v-model="form.model.active.name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系方式：" :rules="[{ required: true, message: ' ' }]" prop="model.active.mobile">
        <el-input type="text"  v-model="form.model.active.mobile" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="活动说明：" :rules="[{ required: true, message: ' ' }]" prop="model.active.dec">
        <el-input type="textarea"  v-model="form.model.active.dec" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item  v-if="form.model.virtual_type ==1"  label="是否关联课程：">
        <el-radio-group v-model="form.model.is_course">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
    </div>
    <div v-if="form.model.is_virtual==1">
        <el-form-item label="关联卡券：" prop="model.gcard_id"  v-auth="'/gcard'">
          <el-select v-model="form.model.gcard_id" clearable filterable>
            <el-option v-for="item in form.gcardList" :value="item.id" :key="item.name" :label="item.name"></el-option>
          </el-select>
        </el-form-item>

       <el-form-item label="选择课程"  v-if="form.model.virtual_type==2 || (form.model.virtual_type ==1 &&form.model.is_course ==1)">
         <el-input type="text" v-model="form.model.course" autocomplete="off" class="max-w460" readonly="">
         <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openCourseDialog">选择章节</el-button>
         </el-input>
       </el-form-item>
       <el-form-item label="免费观看课程权限" v-if="form.model.virtual_type==2 || (form.model.virtual_type ==1 &&form.model.is_course ==1)">
         <el-select v-model="form.model.watch_auth" multiple placeholder="请选择">
           <el-option v-for="(item,index) in form.gradeList" :key="index" :label="item.name"  :value="item.grade_id">
           </el-option>
         </el-select>
           <div class="gray9">选择后，选中的会员等级用户可以免费观看该课程</div>
       </el-form-item>
       <Course :is_open="open_course" :excludeIds='course_id' :islist='false' @close="closeCourseDialog"></Course>
    </div>
    <el-form-item label="运费模板：" :rules="[{ required: true, message: '选择运费模板' }]" prop="model.delivery_id" v-if="form.model.is_virtual==0">
      <el-select v-model="form.model.delivery_id">
        <el-option v-for="item in form.delivery" :value="item.delivery_id" :key="item.delivery_id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="商品状态：">
      <el-radio-group v-model="form.model.product_status">
        <el-radio :label="10">上架</el-radio>
        <el-radio :label="15">定时上架</el-radio>
        <el-radio :label="20">下架</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="form.model.product_status ==15" label="定时上架时间" :rules="[{ required: true, message: ' ' }]" prop="model.product_status_time">
      <el-date-picker
        v-model="form.model.product_status_time"
        type="datetime"
        unlink-panels
        placeholder="请选择上架时间"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions"
        ></el-date-picker>
    </el-form-item>
    <el-form-item label="初始销量：">
      <el-input type="number" min="0" v-model="form.model.sales_initial" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="初始浏览量：">
      <el-input type="number" min="0" v-model="form.model.view_times_initial" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品排序：" :rules="[{ required: true, message: ' ' }]" prop="model.product_sort">
      <el-input type="number" min="0" v-model="form.model.product_sort" class="max-w460"></el-input>
    </el-form-item>
    <Upload v-if="isupload" :isupload="isupload" type="image" @returnImgs="returnImgsFunc">上传封面图片</Upload>
  </div>
  <!--课程选择-->

</template>

<script>
 import Course from '@/components/course/Course.vue';
 import Getpoint from '@/components/map/Getpoint.vue';
 import Upload from '@/components/file/Upload';
export default {
  components: {
    /*腾讯地图拾取器*/
    Getpoint,
    Course,
    Upload
  },
  data() {
    return {
      open_course:false,
      isupload: false,
      /*如果没有后面的-8.64e7就是不可以选择今天的*/
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      course_id:[],
      storeList: [],
    };
  },
  inject: ['form'],
  watch:{
    'form.model.course':{
      handler: function() {
        if(!this.form.model.course){
          this.course_id= [];
          return;
        }
      }
    }
  },
  methods: {
    /*上传封面图*/
    openUpload() {
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.model.custom_poster = e[0].file_path;
      }
      this.isupload = false;
    },
    /* 删除封面 */
    deleteImgPoster() {
      this.form.model.custom_poster = "";
    },
    /*打开章节弹窗*/
    openCourseDialog() {
      console.log(this.open_course)
      this.open_course = true;
    },
    /*关闭题目列表弹窗*/
    closeCourseDialog(e) {
      if (e.type != 'error') {
        console.log(e)
        this.form.model.course  = e.params.course_id;
        this.course_id.push(parseInt( e.params.course_id))
      }
      this.open_course = e.openDialog;
    },
    /*获取经纬度*/
    getMapdataFunc(e) {
      this.form.model.active.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
    },
    /*选择的地址*/
    choseFunc(e){
      this.form.model.active.coordinate=e.location.lat+','+e.location.lng;
      this.form.model.active.address=e.address;

    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Activity.vue